
  // The disclosure action is a real button so it stays keyboard reachable and
  // independently labelled, rather than a click handler bolted onto the icon.
  export default {
    mounted() {
      this.control = this.el.querySelector("[data-text-input-control]")
      this.toggle = this.el.querySelector("[data-password-toggle]")
      this.iconShow = this.el.querySelector("[data-password-icon-show]")
      this.iconHide = this.el.querySelector("[data-password-icon-hide]")

      this.onClick = () => {
        const revealed = this.control.type === "text"
        this.control.type = revealed ? "password" : "text"
        this.toggle.setAttribute("aria-pressed", String(!revealed))
        this.toggle.setAttribute(
          "aria-label",
          revealed ? this.toggle.dataset.showLabel : this.toggle.dataset.hideLabel
        )
        this.iconShow.classList.toggle("hidden", !revealed)
        this.iconHide.classList.toggle("hidden", revealed)
      }

      this.toggle.addEventListener("click", this.onClick)
    },
    destroyed() {
      this.toggle?.removeEventListener("click", this.onClick)
    },
  }
